<template>
	<div class="schoolList">
		<el-card class="list">
			<div slot="header" class="clearfix">
				<span>请选择学校</span>
			</div>
			<div class="list-box">
				<div class="list-item" v-for="(item, i) in tableList" :key="i" @click="itemClick(item)">
					{{item.name}}
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
	import { schoolListApi } from "@/axios/api";
	export default {
		name: "SchoolList",
		data() {
			return {
				tableList:[],
				searchForm:{
					name: '',//学校名称
					isSearchCount:true,
					page:1,
					limit:999
				},
				pathUrl:''
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm=>{    
				vm.pathUrl = from.fullPath;
			})
        },
		created(){
			schoolListApi(this.searchForm).then((res) => {
				if (res.code == 200){
					this.tableList = res.data;
				}
			}).catch((err) => {});
		},
		methods:{
			itemClick(item){
				localStorage.setItem('schoolId',item.id);
				localStorage.setItem('schoolName',item.name);
				if(this.pathUrl == "/"){
					this.$router.push({path: '/school'});
				}else{
					this.$router.go(-1);
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.schoolList{
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		.list{
			width: 25vw;
			.list-box{
				overflow-y: auto;
				height: 800px;
				position: relative;
				.list-item{
					display: flex;
					align-items: center;
					justify-content: center;
					height: 48px;
					background: #e8f3fe;
					margin: 10px;
					color: #7dbcfc;
					cursor: pointer;
					transition: all .3s ease-in;
				}
			}
		}
	}
	/deep/.el-card__header{
		padding: 20px;
	}
	/deep/.el-card__body {
		padding: 20px;
	}
</style>